import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet'

import Header from './components/Partials/Header/Header'
import Footer from './components/Partials/Footer/Footer'
import EHPCalculator from './components/EHPCalculator/EHPCalculator'
import BJ5Calculator from './components/BJ5Calculator/BJ5Calculator'
import Credits from './pages/Credits'

import './styles/main.scss'

const App = props => {
  return (
    <>
      <Helmet>
        <html lang={props.language} />
      </Helmet>
      <div className="App full-page-component">
        <BrowserRouter basename="/">
          <Header />
          <main id="main" className="container">
            <Switch>
              <Route path="/bj5" exact component={BJ5Calculator} />
              <Route path="/credits" exact component={Credits} />
              <Route path="/" exact component={EHPCalculator} />
              <Redirect to="/" />
            </Switch>
          </main>
          <Footer />
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
